export default __webpack_public_path__ + "static/media/timer.ced86d3d.svg";